import {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  Image,
  Platform,
} from "react-native";
import React, { useRef, useState } from "react";
import AttachIcon from "../../assets/svg/AttachIcon";
import MicrophoneIcon from "../../assets/svg/MicrophoneIcon";
import { danger, gray, primary, shadowSm, white } from "../../colors";
import SendIcon from "../../assets/svg/SendIcon";
import { useSelector } from "react-redux";
import * as ImagePicker from "expo-image-picker";
import { Ionicons } from "@expo/vector-icons";
import MyButton from "../custom/MyButton";
import { Audio } from "expo-av";
import MyText from "./MyText";
import translate from "../../functions/translate";
import { useEffect } from "react";

export default function UploadSection(props) {
  const [mode, setMode] = useState(1);
  const main = useSelector((store) => store.main);

  const [image, setImage] = useState(null);
  const changeHandler = (event) => {
    setImage(event.target.files[0]);
  };
  const fileInput = useRef(null);
  const selectFile = () => {
    fileInput.current.click();
  };
  const [imageSend, setImageSend] = useState(false);
  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      quality: 1,
    });

    if (!result.canceled) {
   
      setImage(result);
    }
  };

  useEffect(() => {
    if (image !== null) {
      props.setImage(
        Platform.OS !== "web"
          ? {
              uri: image.uri,
              type: "image/png", // or photo.type
              name: "avatar.png",
            }
          : image
      );
    }
  }, [image]);

  return (
    <View
      style={{
        alignItems: "center",
        zIndex: 100,
        backgroundColor: white,
        marginVertical: 20,
        width: "100%",
      }}
    >
      {!(
        (Platform.OS === "web" &&
          fileInput.current !== null &&
          fileInput.current?.value !== "") ||
        (image && Platform.OS !== "web")
      ) && (
        <TouchableOpacity
          onPress={Platform.OS === "web" ? selectFile : pickImage}
          style={{
            width: "94%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 100,
            borderWidth: 1,
            borderRadius: 10,
            borderStyle: "dashed",
            borderColor: props.borderColor ? props.borderColor : gray,
          }}
        >
          <MyText style={{ color: props.textColor ? props.textColor : gray }}>
            {translate("upload child image")}
          </MyText>
          {mode === 1 && (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {Platform.OS === "web" ? (
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={fileInput}
                  onChange={changeHandler}
                />
              ) : null}
            </View>
          )}
        </TouchableOpacity>
      )}

      <View style={{ width: "100%", alignItems: "center" }}>
        {Platform.OS === "web" &&
          fileInput.current !== null &&
          fileInput.current?.value !== "" && (
            <View
              style={{
                marginVertical: 10,
                padding: 10,
                width: "90%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setImage(null);
                  fileInput.current.value = "";
                }}
              >
                <Ionicons name="close" size={24} color={danger} />
              </TouchableOpacity>
              <MyText>فایل آپلود شده</MyText>
            </View>
          )}
        {image && Platform.OS !== "web" && (
          <View
            style={{
              marginVertical: 10,
              padding: 10,
              width: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TouchableOpacity onPress={() => setImage(null)}>
              <Ionicons name="close" size={24} color={danger} />
            </TouchableOpacity>
            <View style={{ width: "100%", alignItems: "center" }}>
              <Image
                source={{ uri: image.assets[0].uri }}
                style={{ width: 160, height: 160, marginTop: 10 }}
              />
            </View>
          </View>
        )}
      </View>
    </View>
  );
}
